import { render } from "./RoundCounter.vue?vue&type=template&id=10fbc686&scoped=true"
import script from "./RoundCounter.vue?vue&type=script&lang=js"
export * from "./RoundCounter.vue?vue&type=script&lang=js"

import "./RoundCounter.vue?vue&type=style&index=0&id=10fbc686&scoped=true&lang=css"

import exportComponent from "C:\\Data\\lightsOut\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fbc686"]])

export default __exports__